import React from "react";
import { frameworkSteps } from "../../data/content";
import { SectionCta } from "../SectionCta";
export function Story() {
  return <section className="bg-white px-5 py-16 md:py-24" data-id="element-264" data-mp="1niutlcaq7hhs">
      <div className="mx-auto max-w-3xl" data-id="element-265" data-mp="21jntkcjsr4sa">
        <h2 className="text-center font-serif text-[30px] font-black leading-[1.1] text-navy md:text-5xl" data-id="element-266" data-mp="21im6tatf4tuq">
          From <em className="italic text-gold-dark" data-id="element-267" data-mp="1whyg6q93qf11">Looking</em> at an Abdominoplasty Case… to{" "}
          <em className="italic text-gold-dark" data-id="element-268" data-mp="18uqai77rh3yh">Analyzing</em> It With a System
        </h2>

        <div className="mt-8 space-y-4 text-[17px] leading-relaxed text-navy/80 md:text-lg" data-id="element-269" data-mp="14upxmr0b90tj">
          <p data-id="element-270" data-mp="1ilunj1dvmeqo">I've spent years studying how experienced surgeons approach complex aesthetic cases.</p>
          <p data-id="element-271" data-mp="1ds0bmk4ij425">And one thing became increasingly clear to me:</p>
          <p className="border-l-4 border-gold pl-4 font-serif text-xl font-bold italic text-navy md:text-2xl" data-id="element-272" data-mp="q379g5xarzz3">
            Knowing more information is not always the same as knowing how to organize that information when a real
            case is in front of you.
          </p>
          <p data-id="element-273" data-mp="mh44lrei6hb5">You can read papers. You can watch surgical demonstrations. You can attend conferences. You can collect hundreds of pages of notes.</p>
          <p data-id="element-274" data-mp="r8m5kfgj0hw4">And still look at a new abdominoplasty case and wonder:</p>
          <p className="text-center font-serif text-2xl font-black text-navy" data-id="element-275" data-mp="w7gln9n3zscj">“Where exactly should I start?”</p>
          <p data-id="element-276" data-mp="3upukorjvd3n5">
            That's the problem I created <strong className="text-navy" data-id="element-277" data-mp="3ur5nop5hq7d7">The Abdominoplasty Master System™</strong> to
            address.
          </p>
          <p data-id="element-278" data-mp="8humgm6qld4j">
            The goal isn't to replace surgical training, mentorship, clinical guidelines, institutional protocols or
            professional judgment. The goal is to give you a <strong className="text-navy" data-id="element-279" data-mp="cgv5o5t4mhs2">repeatable educational framework</strong> for practicing case analysis.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-16 max-w-5xl" data-id="element-280" data-mp="1nxbkbwwuwudv">
        <div className="text-center" data-id="element-281" data-mp="1o07inmcm9l2u">
          <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-gold-dark" data-id="element-282" data-mp="3ky7o2ils0fjg">The framework</p>
          <h3 className="mt-3 font-serif text-[28px] font-black leading-tight text-navy md:text-4xl" data-id="element-283" data-mp="3fyuvric4yg9h">
            A 15-Minute System for Structured Case Analysis
          </h3>
          <p className="mx-auto mt-3 max-w-2xl text-[17px] text-navy/70" data-id="element-284" data-mp="3p02svx2x1b1z">
            Instead of jumping randomly between information, you work through a repeatable sequence:
          </p>
        </div>

        <ol className="mt-10 grid gap-3 md:grid-cols-2 lg:grid-cols-3 lg:gap-4" data-id="element-285" data-mp="2x9y7pw7c0jzp">
          {frameworkSteps.map((step, i) => <li key={step.title} className="flex gap-4 rounded-2xl bg-navy p-5 text-white" data-id="element-286" data-mp="3b1l4ry93lwjj" data-mpi={i}>
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-gold font-serif text-2xl font-black text-navy" data-id="element-287" data-mp="369b9s3t4m6ae">
                {i + 1}
              </span>
              <div data-id="element-288" data-mp="2dm7b0gkmmo72">
                <p className="text-lg font-extrabold uppercase tracking-wide text-gold" data-id="element-289" data-mp="2dknrmh3obx12">{step.title}</p>
                <p className="mt-1 text-[15px] leading-snug text-white/80" data-id="element-290" data-mp="t1tv7l3h46ro">{step.question}</p>
              </div>
            </li>)}
        </ol>

        <p className="mt-8 text-center font-serif text-2xl font-black text-navy md:text-3xl" data-id="element-291" data-mp="k2yjxulko6hi">
          One case. One framework. <em className="italic text-gold-dark" data-id="element-292" data-mp="p2us861ayk2v">Fifteen focused minutes.</em>
        </p>

        <SectionCta label="I want to analyze cases with a system" data-id="element-293" data-mp="1cr48ytjnshn5" />
      </div>
    </section>;
}